import {
  Component,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import { MessageService } from 'primeng/api';
import { ProfileService } from 'src/app/core/services/profile.service';

@Component({
  selector: 'forced-password-change',
  templateUrl: './forced-password-change.component.html',
  styleUrls: ['./forced-password-change.component.scss'],
})
export class ForcedPasswordChangeComponent {
  @ViewChild('passwordInput') passwordInput: ElementRef;
  IsLoading: boolean = false;
  hide: boolean = true;
  hideConfirm: boolean = true;
  resp: any = undefined;
  overlayWidth: string = '0px';
  changeSuccess: boolean = false;
  passValidation: boolean = false;

  constructor(
    private router: Router,
    private httpService: ApiHttpService,
    private el: ElementRef,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private profileService: ProfileService
  ) {}

  submitted: boolean = false;
  loginError: string = '';
  passMatch: boolean = false;
  emptyFieldPass: boolean = false;
  emptyFieldConfirm: boolean = false;

  forcedPasswordChangeForm = new FormGroup({
    password: new FormControl<any>(null, [Validators.required]),
    confirm_password: new FormControl(null, [Validators.required]),
  });

  ngAfterViewInit() {
    const inputWidth = this.passwordInput?.nativeElement?.offsetWidth;
    this.overlayWidth = `${inputWidth}px`;
    this.cdr.detectChanges();
  }

  passwordRequirements: {
    length: boolean;
    specialChar: boolean;
    number: boolean;
    capitalLetter: boolean;
  } = {
    length: false,
    specialChar: false,
    number: false,
    capitalLetter: false,
  };

  checkPasswordRequirements() {
    this.emptyFieldPass = false;
    this.emptyFieldConfirm = false;
    let password: string | null = this.forcedPasswordChangeForm.get('password')?.value;

    if (password) {
      this.passwordRequirements.length = password.length >= 8;
      this.passwordRequirements.specialChar = /[!@#$%^&*(),.?":{}|<>]/g.test(
        password
      );
      this.passwordRequirements.number = /\d/.test(password);
      this.passwordRequirements.capitalLetter = /[A-Z]/.test(password);
      this.passValidation = this.passwordRequirements.length && this.passwordRequirements.specialChar && this.passwordRequirements.number && this.passwordRequirements.capitalLetter;
    } else {
      this.passwordRequirements.length = false;
      this.passwordRequirements.specialChar = false;
      this.passwordRequirements.number = false;
      this.passwordRequirements.capitalLetter = false;
      this.passValidation = false;
      this.resp = undefined;
    }
  }

  async handleSubmit() {
    this.submitted = true;
    this.focusIN();
    if (
      this.forcedPasswordChangeForm.get('password')?.valid &&
      this.forcedPasswordChangeForm.get('confirm_password')?.valid
    ) {
      this.IsLoading = true;
      let payload = this.forcedPasswordChangeForm.value;
      
      // Get user id from profile data
      const userId = this.profileService.getuserProfileData()?.id;
      console.log(this.profileService.getuserProfileData());
    //   if (!userId) {
    //     this.messageService.add({ 
    //       severity: 'error', 
    //       summary: 'Failed', 
    //       detail: 'User information not found. Please login again.', 
    //       key: 'app_notiy' 
    //     });
    //     this.IsLoading = false;
    //     return;
    //   }
      
      // API call to change password
      this.resp = await this.httpService.put(
        `/user_password_update/0`,
        payload
      );
      
      if (this.resp.status == 200) {
        this.changeSuccess = true;
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: 'Password changed successfully. Please login with your new password.', 
          key: 'app_notiy' 
        });
        
        // Log out the user after successful password change
        setTimeout(() => {
          this.logout();
        }, 2000);
      } else {
        this.passMatch = this.resp.error.message == 'The password field confirmation does not match.' ? false : true;
        this.IsLoading = false;
        this.submitted = false;
        this.changeSuccess = false;
        this.emptyFieldPass = false;
        this.emptyFieldConfirm = false;
        
        if (this.resp.error?.message) {
          this.messageService.add({ 
            severity: 'error', 
            summary: 'Failed', 
            detail: this.resp.error.message, 
            key: 'app_notiy' 
          });
        }
      }
    }
    else{
      if(!this.forcedPasswordChangeForm.get('password')?.value){
        this.emptyFieldPass = true;
      }
      if(!this.forcedPasswordChangeForm.get('confirm_password')?.value){
        this.emptyFieldConfirm = true;
      }
    }
  }

  logout() {
    // Clear all user data
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_permissions');
    this.profileService.clearUserProfileData();
    
    // Navigate to login
    this.router.navigate(['/login']);
  }

  focusIN() {
    const invalidControl = this.el.nativeElement.querySelector('input');
    if (invalidControl) {
      invalidControl.focus();
    }
    this.resp = undefined;
  }
}

